import {
  RADAR_SESSION_STARTED,
  RADAR_POLL_ATTEMPTED,
  RADAR_RESPONSE_RECEIVED,
  RADAR_POLL_COMPLETED,
} from '../helpers/constants/actionsConstants';

import type {
  RadarSessionStartedAction,
  RadarPollAttemptedAction,
  RadarResponseReceivedAction,
  Itinerary,
  RadarPollCompletedAction,
} from '../selectors/dealHunterTypes';
import type { TripDuration } from '../selectors/types';

export const setRadarSessionStarted = (
  tripDuration: TripDuration,
): RadarSessionStartedAction => ({
  type: RADAR_SESSION_STARTED,
  payload: {
    tripDuration,
  },
});

export const setRadarPollAttempted = (
  tripDuration: TripDuration,
): RadarPollAttemptedAction => ({
  type: RADAR_POLL_ATTEMPTED,
  payload: {
    tripDuration,
  },
});

export const setRadarResponseReceived = (
  tripDuration: TripDuration,
  cheapestItinerary: Itinerary,
  pollingSessionToken?: string,
  cheapestDirectItinerary?: Itinerary,
): RadarResponseReceivedAction => ({
  type: RADAR_RESPONSE_RECEIVED,
  payload: {
    tripDuration,
    cheapestItinerary,
    pollingSessionToken,
    cheapestDirectItinerary,
  },
});

export const setRadarPollCompleted = (
  tripDuration: TripDuration,
): RadarPollCompletedAction => ({
  type: RADAR_POLL_COMPLETED,
  payload: {
    tripDuration,
  },
});
